//TODO: https://localforage.github.io/localForage/
//TODO: VUE localstorage extended - https://github.com/ricardogobbosouza/v-localforage
import { defineModule } from "direct-vuex"
import store, { moduleActionContext, moduleGetterContext } from "."
import ApiFactory from "Api/ApiFactory";
import ProductListHelper from "Helpers/ProductListHelper";


export interface ICustomerAgreementState {
    list: string[]
}


const initial : ICustomerAgreementState = {
    list : null,
    
}

let promise: Promise<any>;
const customerAgreement = defineModule({
    namespaced: true,
    state: (): ICustomerAgreementState => initial
    ,
    getters: {
    },
    mutations: {
        SET_List(state, list: string[]) {
            state.list = list;
        },
    },
    actions: {
        async load(context) : Promise<any> {
            const { dispatch, commit, getters, state } = authActionContext(context);
            
            return promise || (promise = new Promise(async (resolve, reject) => {
                let productKeys = await ProductListHelper.GetAllProductKeys();
                const client =  await ApiFactory.getCustomerAgreementClient()
                const result = await client.getAll(productKeys);   
                commit.SET_List(result.productKeys);
                resolve();
            })); 
        },
    }
    
});

export default customerAgreement
const mod1GetterContext = (args: [any, any, any, any]) => moduleGetterContext(args, customerAgreement);
const authActionContext = (context: any) => moduleActionContext(context, customerAgreement);